<template>
  <el-dialog :visible.sync="open" :title="$t('campaign.modal.create.title')" :before-close="close" width="390px">
    <el-form>
      <div class="form-group">
        <label>{{ $t('campaign.modal.create.fields.name') }}</label>
        <el-input type="text" v-model="fields.name[lang]" @keyup.enter.native="save"></el-input>
      </div>
      <div class="form-group">
        <el-checkbox v-model="period_limited">{{ $t('campaign.modal.create.fields.period') }}</el-checkbox>
      </div>
      <div class="form-group">
        <el-date-picker
          :disabled="!period_limited"
          v-model="period"
          type="daterange"
          :start-placeholder="$t('campaign.modal.create.fields.date.start')"
          :end-placeholder="$t('campaign.modal.create.fields.date.end')"
          @change="onPeriodSelected"
        ></el-date-picker>
      </div> </el-form
    ><span slot="footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="save" :loading="saving">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['open', 'campaign'],

  data() {
    return {
      saving: false,

      visible: true,

      events: [],
      fields: {
        name: {},
        activationdate: null,
        deactivationdate: null
      },
      period_limited: false,
      period: null
    }
  },
  computed: {
    ...mapGetters('account', {
      currentSite: 'currentSite',
      lang: 'defaultLang'
    })
  },
  watch: {
    period_limited: function(value) {
      if (!value) {
        this.period = null
      }
    }
  },
  methods: {
    ...mapActions('campaigns', ['addCampaign', 'updateCampaign']),
    ...mapActions('badges', ['loadBadges']),

    onPeriodSelected(period) {
      if (period) {
        if (period[0]) {
          this.fields.activationdate = period[0]
          this.fields.deactivationdate = period[1]
        }
      } else {
        this.fields.activationdate = null
        this.fields.deactivationdate = null
      }
    },
    close() {
      this.$emit('close', true)
    },
    save() {
      // Check if fields required are not empty
      console.log('save')
      if (!this.fields.name[this.lang]) {
        return this.$notify.info({
          message: this.$t('notifications.campaign.defineName'),
          title: 'Warning',
          type: 'warning'
        })
      }
      this.fields.activationdate = this._setDate(this.fields.activationdate, this.currentSite.timezone, true)
      this.fields.deactivationdate = this._setDate(this.fields.deactivationdate, this.currentSite.timezone, false)

      if (!this.period_limited) {
        this.fields.activationdate = null
        this.fields.deactivationdate = null
      } else {
        if (!this.fields.activationdate) {
          return this.$notify.info({
            message: this.$t('notifications.campaign.startDate'),
            title: 'Warning',
            type: 'warning'
          })
        }
        if (!this.fields.deactivationdate) {
          return this.$notify.info({
            message: this.$t('notifications.campaign.endDate'),
            title: 'Warning',
            type: 'warning'
          })
        }
      }

      this.saving = true

      if (this.fields.id) {
        this.updateCampaign({ campaign: this.fields, sitekey: this.$route.params.site })
          .then(() => {
            this.$notify({ message: this.$root.$t('notifications.campaign.edited'), title: 'Success', type: 'success' })
            this.loadBadges().then(() => {
              this.close()
            })
          })
          .catch(response => {
            this.$notify.error({
              title: this.$root.$t('api.' + response.data.code + '.title'),
              message: this.$root.$t('api.' + response.data.code + '.message')
            })
            this.saving = false
          })
      } else {
        this.addCampaign({ campaign: this.fields, sitekey: this.$route.params.site })
          .then(() => {
            this.$notify({ title: 'Success', message: this.$root.$t('notifications.campaign.added'), type: 'success' })
            this.close()
          })
          .catch(response => {
            this.$notify.error({
              title: this.$root.$t('api.' + response.data.code + '.title'),
              message: this.$root.$t('api.' + response.data.code + '.message')
            })
            this.saving = false
          })
      }
    }
  },
  mounted() {
    if (this.campaign && this.campaign.id) {
      this.fields = JSON.parse(JSON.stringify(this.campaign))

      if (this.fields.activationdate && this.fields.deactivationdate) {
        this.period_limited = true
        this.period = []
        this.period.push(this.fields.activationdate)
        this.period.push(this.fields.deactivationdate)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/campaigns/FormCampaign.vue